export function defaultMovieForm() {
  return {
    title: '',
    category: '',
    director: '',
    year: '',
    original: '',
    imageurl: '',
    youtubeId: '',
    synopsis: '',
    casting: '',
    language: 'MULTI',
    duration: '',
    date: new Date().toISOString().substring(0, 10),
    seen: 'N',
    rating: '3',
    path: 'G:/movies',
    filename: '',
    tag: '',
    quality: '1080p',
    marked: '',
    actorname1: '',
    actorname2: '',
    actorname3: '',
    actorname4: '',
    actorname5: '',
    actorname6: '',
    actorpix1: '',
    actorpix2: '',
    actorpix3: '',
    actorpix4: '',
    actorpix5: '',
    actorpix6: '',
  }
}

export function timeConvert(minutes) {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${hours}h${mins}`
}

export function appendMovieFormData(formData, movie) {
  Object.entries(movie).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value))
    }
  })
}

export function posterSrc(post) {
  if (post?.imageurl) return post.imageurl
  if (post?.image) return `/uploads/${post.image}`
  return ''
}
